import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { CloseIcon } from "../../../shared/components/Icons";

type Props = {
  closeModal: () => void;
  discardChanges?: () => void;
  handleSaveSlots: () => void;
  isLoading: boolean;
};

const BackBlockerDialog = ({
  closeModal,
  discardChanges,
  handleSaveSlots,
  isLoading,
}: Props) => {
  return (
    <Dialog open onClose={closeModal} maxWidth="xl">
      <DialogTitle
        fontSize={"32px"}
        justifyContent={"center"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        <Typography fontSize={"24px"} lineHeight={"32px"} fontWeight={700}>
          Unsaved Changes
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={closeModal}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          px: 4,
          py: 2,
          width: "50vw",
        }}
      >
        <Typography variant="body2" textAlign={"center"} px={4}>
          Do you want to save the slots before leaving the page?
        </Typography>

        <Box
          display="flex"
          justifyContent="flex-end"
          sx={{ mt: 1, mb: 1 }}
          gap={2}
        >
          <Button
            variant="text"
            sx={{ mt: 2 }}
            color="error"
            onClick={discardChanges}
          >
            Discard Changes
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 2 }}
            onClick={closeModal}
          >
            Keep editing
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BackBlockerDialog;
